<template>
 <div id="app">
   <router-view></router-view>
 </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: Helvetica, sans-serif;
  text-align: center;
}
</style>
